import { render, staticRenderFns } from "./vattiCdrCount.vue?vue&type=template&id=71db249f"
import script from "./vattiCdrCount.vue?vue&type=script&lang=js"
export * from "./vattiCdrCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports